<div class="hz-content" style="{{style}}">
  <div class="hz-icon-main" hz-click="goto($event)">
    <img class="hz-icon" src={{icon}} alt="" />
  </div>
</div>
